import { getApp } from "firebase/app";
import { getFirestore, collection } from "firebase/firestore";

// =============================== BASE  ===============================  //
const app = getApp();

export const REF = {
  NAME: "(default)",
  COLLECTIONS: {
    PAPER: "paper",
    COMPUTER: "computer",
    DEBUG: "debug",
  },
};

export const getRefs = () => {
  const firestore = getFirestore(app, REF.NAME);
  const CREF = {
    paper: collection(firestore, REF.COLLECTIONS.PAPER),
    computer: collection(firestore, REF.COLLECTIONS.COMPUTER),
    debug: collection(firestore, REF.COLLECTIONS.DEBUG),
  };
  return CREF;
};
